module.exports = __webpack_public_path__ + "static/img/Claudia.247a366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Claudia.jpg
// module id = 199
// module chunks = 1